import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import TimelineSection from "../shared/TimelineSection";
import OrganizationStructure from "../shared/OrganizationStructure";

const ProfilDHIContent: React.FC = () => {
  const timelineEvents = [
    {
      period: "1952 - 1955",
      title: "Periode Seksi INTERPOL",
      description:
        "Pada tahun 1952 Pemerintah Indonesia mengirim 2 orang utusan sebagai peninjau pada Sidang Umum ICPO-INTERPOL ke-21 di Stockholm, Swedia. Tahun 1954, Indonesia resmi diterima menjadi anggota ICPO-INTERPOL. Dengan Surat Keputusan Perdana Menteri No. 245/PM/1954, Jawatan Kepolisian Negara ditunjuk sebagai NCB Indonesia.",
    },
    {
      period: "1955 - 1960",
      title: "Periode NCB Indonesia",
      description:
        "Pada tahun 1956, dikeluarkan Order Kepala Kepolisian Negara No. 25/I/1956 yang melepaskan Seksi INTERPOL dari Dinas Reserse Kriminil menjadi NCB Indonesia yang berada langsung dibawah Kepala Kepolisian Negara.",
    },
    {
      period: "1961 - 1966",
      title: "Periode Dinas INTERPOL",
      description:
        "Akibat keluarnya Indonesia dari keanggotaan PBB, NCB Indonesia ditetapkan sebagai Dinas INTERPOL dibawah Direktur Reserse Kriminal Depak berdasarkan Order Direktur Reserse/Depak No. 9/UM/1964.",
    },
    {
      period: "1967 - 1968",
      title: "Periode Biro INTERPOL",
      description:
        "Berdasarkan Peraturan Menteri/Pangak No. 5/Prt/MP/1967, pada Markas Besar Angkatan Kepolisian dibentuk Biro INTERPOL yang berada langsung dibawah Menteri/Pangak.",
    },
    {
      period: "1969 - 1975",
      title: "Periode Sekretariat NCB Indonesia",
      description:
        "Dengan Surat Keputusan Pangak No. Pol. : 21/SK/Pangak/1969, dibentuk Sekretariat NCB Indonesia yang berada dibawah Komandan Jenderal Komando Reserse.",
    },
    {
      period: "1976 - 1983",
      title: "Periode Bakersinpol",
      description:
        "Sesuai Keputusan Menhankam Pangab No. Kep/15/IV/1976, dibentuk Badan Kerjasama Internasional Kepolisian RI (Bakersinpol) sebagai Badan Pelaksanan Pusat yang berada langsung dibawah Kapolri.",
    },
    {
      period: "1984 - 1996",
      title: "Periode Sekretariat NCB-INTERPOL",
      description:
        "Dengan Keputusan Pangab No. Kep/11/P/III/1984, Bakersinpol berubah menjadi Sekretariat NCB-INTERPOL yang berkedudukan di bawah Kapolri.",
    },
    {
      period: "1997 - 2009",
      title: "Periode Sekretariat NCB-INTERPOL Indonesia",
      description:
        "Berdasarkan Keputusan Pangab No. Kep/09/X/1997, nama organisasi menjadi Sekretariat NCB-INTERPOL Indonesia. Pada tahun 2008, organisasi dikembangkan dengan membawahi 6 bidang.",
    },
    {
      period: "2010 - sekarang",
      title: "Periode Divhubinter Polri",
      description:
        "Berdasarkan Peraturan Kapolri nomor 21 tahun 2010, organisasi dikembangkan menjadi Divisi Hubungan Internasional (Divhubinter) Polri yang terbagi dalam 2 biro yaitu Sekretariat NCB-INTERPOL Indonesia dan Biro Misi Internasional.",
    },
  ];

  const organizationUnits = [
    {
      name: "Sekretariat NCB-INTERPOL Indonesia",
      abbreviation: "Set NCB-INTERPOL Indonesia",
      description:
        "Unsur pelaksana utama yang bertugas menyelenggarakan kerja sama internasional dalam penanggulangan kejahatan transnasional dan internasional melalui wadah ICPO-INTERPOL.",
      subUnits: [
        { name: "Bagian Kejahatan Transnasional & Internasional" },
        { name: "Bagian Komunikasi Internasional" },
        { name: "Bagian Perbatasan Nasional" },
      ],
    },
    {
      name: "Biro Misi Internasional",
      abbreviation: "Romisinter",
      description:
        "Unsur pelaksana utama yang bertugas mengelola tugas misi internasional meliputi misi perdamaian, misi kemanusiaan, dan pengembangan kapasitas personel dan logistik Polri.",
      subUnits: [
        { name: "Bagian Perdamaian dan Kemanusiaan" },
        { name: "Bagian Pengembangan Kapasitas" },
      ],
    },
    {
      name: "Biro Kerja Sama Internasional",
      abbreviation: "Rokersin",
      description:
        "Unsur pelaksana utama yang bertugas membina dan melaksanakan kerja sama internasional melalui perjanjian internasional, pertemuan internasional, dan perwakilan Polri di luar negeri.",
      subUnits: [
        { name: "Bagian Perjanjian Internasional" },
        { name: "Bagian Konferensi Internasional" },
        { name: "Bagian Perwakilan Internasional" },
      ],
    },
  ];

  const OverviewContent = () => (
    <div className="p-8">
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-bold mb-4">Sekilas Divhubinter Polri</h2>
        <p className="text-base-content/70 leading-relaxed mb-6">
          Sejalan dengan tujuan nasional yang diamanatkan dalam Pembukaan
          Undang-undang Dasar Negara Republik Indonesia Tahun 1945 alenia ke-4
          dan RPJPN tahun 2005 – 2025, maka Polri sebagai bagian dari aparatur
          pemerintahan Indonesia telah berperan aktif di dalam mewujudkan kerja
          sama Internasional berupa penanganan kejahatan transnasional dan
          kejahatan internasional, penggelaran personel Polri dalam misi
          pemeliharaan perdamaian Perserikatan Bangsa-Bangsa (PBB) dan misi
          kemanusiaan dalam konteks perbantuan tenaga ahli pada daerah atau
          negara yang mengalami bencana alam.
        </p>
        <p className="text-base-content/70 leading-relaxed mb-6">
          Disamping itu Polri secara aktif dan berkelanjutan juga melaksanakan
          misi pengembangan kapasitas serta memberikan perlindungan dan
          pelayanan bagi warga negara Indonesia (WNI) di luar negeri.
        </p>
        <p className="text-base-content/70 leading-relaxed mb-6">
          Apa yang dilakukan oleh Polri tersebut di atas merupakan penjabaran
          misi Polri sesuai dengan Grand Strategy Polri tahun 2005 – 2025 yang
          didalamnya terdapat wujud nyata dari Perpolisian Internasional yang
          menjadi tugas pokok dan tanggung jawab dari Divisi Hubungan
          Internasional Polri (Divhubinter Polri).
        </p>
        <p className="text-base-content/70 leading-relaxed">
          Divhubinter Polri sebagai salah satu unsur pembantu pimpinan Polri
          terbentuk sejak tahun 2010. Namun keberadaan dan pelaksanaan tugas
          pokoknya dalam bidang hubungan dan kerjasama Internasional sudah ada
          sejak tahun 1952 yang pada saat itu dilaksanakan oleh NCB INTERPOL
          Indonesia.
        </p>
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "📋",
      component: <OverviewContent />,
    },
    {
      id: "history",
      label: "Sejarah",
      icon: "📅",
      component: <TimelineSection events={timelineEvents} />,
    },
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: (
        <OrganizationStructure
          mainTitle="Struktur Organisasi Divhubinter Polri"
          mainDescription="Divisi Hubungan Internasional Polri terdiri dari 3 unsur pelaksana utama yang menjalankan fungsi hubungan internasional Polri."
          units={organizationUnits}
        />
      ),
    },
  ];

  return (
    <ProfilePageTemplate
      title="Profil DHI"
      subtitle="Divisi Hubungan Internasional Polri"
      icon="🏛️"
      breadcrumbBase="Tentang"
      tabs={tabs}
      footerTitle="Divisi Hubungan Internasional Polri"
      footerDescription="Mewujudkan kerja sama internasional yang profesional dalam mendukung tugas Polri sebagai pelindung, pengayom, dan pelayan masyarakat."
      footerStats={[
        { label: "Tahun Berdiri", value: "2010" },
        { label: "Biro Utama", value: "3" },
        { label: "Misi Internasional", value: "Aktif" },
      ]}
    />
  );
};

export default ProfilDHIContent;
